/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { UpdateCheckListItemRequestViewModel } from "../types/UpdateCheckListItemRequestViewModel.ts";

export const updateCheckListItemRequestViewModelSchema = z.object({
  description: z.string().nullish(),
  active: z.optional(z.boolean()),
}) as unknown as ToZod<UpdateCheckListItemRequestViewModel>;
